// Figma "Banner · Viewing an athlete" (Accent): a coach looking at an
// athlete's data, read-only, with Back to my data. Stays at the top of main
// while the page scrolls, as the strip it replaces did; spins while the
// switch is loading. Mounted by Layout in place of its inline strip.
import React from 'react';
import { useCoaching } from '../../context/CoachingContext';
import { Button } from '../ds';
import { Spinner } from '../auth/AuthLayout';
import { cn } from '../../lib/utils';
import { BANNER_INSET, PageBanner } from './PageBanner';

export function ViewingBannerView({ username, switching = false, onBack }) {
  return (
    <div className={cn('sticky top-0 z-30 bg-bg-canvas pb-1', BANNER_INSET)}>
      <PageBanner tone="accent" icon={switching ? <Spinner size={16} /> : null}
        action={<Button kind="secondary" size="small" onClick={onBack}>Back to my data</Button>}>
        Viewing {username}’s data · read-only. Edits, check-ins and the composer are hidden.
      </PageBanner>
    </div>
  );
}

export default function ViewingBanner() {
  const { viewingAthlete, isViewingAthlete, isSwitchingAthlete, switchToSelf } = useCoaching();
  if (!isViewingAthlete) return null;
  return <ViewingBannerView username={viewingAthlete?.username} switching={isSwitchingAthlete} onBack={switchToSelf} />;
}
